import { styled } from '@mui/system'
import { Box, Button, FormControl } from '@mui/material'

export const ActionBox = styled(Box)(({ theme }) => ({
  justifyContent: 'space-between',
  display: 'flex',
  boxSizing: 'border-box',
  margin: '1rem 0',
  height: '5rem',
  padding: '0.5rem 1.5rem',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    height: 'auto',
  },
}))

export const ActionDivButtonGroup = styled('div')(({ theme }) => ({
  height: '100%',
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0.6rem 1rem',
  },
}))

export const ActionButtonItem = styled(Button)(({ theme }) => ({
  margin: '0 1rem',
  height: '100%',
  width: '16rem',
  [theme.breakpoints.down('lg')]: {
    margin: '0 0.6rem',
    width: '10rem',
  },
  [theme.breakpoints.down('md')]: {
    width: 'auto',
    margin: '0.6rem 1rem',
  },
}))

export const ActionFormControl = styled(FormControl)(({ theme }) => ({
  margin: '0 1rem',
  height: '100%',
  width: '16rem',
  minWidth: '12rem',
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    margin: '1rem 1rem',
    width: 'auto',
  },
}))
